import { useState } from 'react'
import { observer } from 'mobx-react'
import _ from 'lodash'

import Tabs from './Tabs'
import Legend from './Legend'
import MixLabels from './MixLabels'
import Risk from './Risk'
import Breakdown from './Breakdown'
import { buildHoldingsByCategory, buildCategoryTotals } from './investmentBreakdown'

const categoryOrder = { 'Cash': 1, 'Bonds': 2, 'Stocks': 3, 'Misc': 4, 'Target-Date': 5 }

function InvestmentMixChart(props) {
  const [active, setActive] = useState('assetClassBreakdown')
  function handleChange(active) {
    setActive(active)
  }

  const { allTabsEnabled, store, ...propsRest } = props
  const { allBreakdown } = store
  const selectedBreakdown =
    allBreakdown.filter(account => account.name === props.selectedaccount)[0] || []

  // "Investment category" and "investment holdings" are both built from
  // `investmentHoldings` (grouped by asset-class type) rather than the
  // `investmentCategory`/`assetClassBreakdown` fields - the backend never
  // populates those with a Misc/Other bucket, and (since backend change
  // #21051) `investmentCategory` isn't reliably aggregated by asset class for
  // retail/IRA accounts. See investmentBreakdown.js.
  let sortedBreakdown
  if (active === 'investmentHoldings') {
    sortedBreakdown = buildHoldingsByCategory(selectedBreakdown.investmentHoldings)
  } else if (active === 'investmentCategory') {
    sortedBreakdown = buildCategoryTotals(selectedBreakdown.investmentHoldings)
  } else {
    sortedBreakdown = _.sortBy(selectedBreakdown[active], [
      category => categoryOrder[category.name],
    ])
  }
  const anyOldValues =
    sortedBreakdown.filter(
      x =>
        x.assets.filter(asset => {
          return asset.oldValue !== null
        }).length > 0
    ).length > 0

  // Hide the Old Mix for Asset Class Breakdown Tab
  const hideOld = active === 'assetClassBreakdown'
  const hideOldRisk = active === 'assetClassBreakdown' || !anyOldValues

  return (
    <div {...propsRest}>
      <Tabs
        store={store}
        active={active}
        handleChange={handleChange}
        allTabsEnabled={allTabsEnabled}
        theme={props.theme}
      />

      <Legend />

      <MixLabels hideOld={hideOld} theme={props.theme} />

      <Risk store={store} hideOld={hideOldRisk} theme={props.theme} />

      <Breakdown
        active={active}
        hideOld={hideOld}
        theme={props.theme}
        sortedBreakdown={sortedBreakdown}
      />
    </div>
  )
}

export default observer(InvestmentMixChart)
